import { FC, useEffect, useState } from 'react'

import { FontStyles } from 'styles/fonts'
import { GlobalStyle } from 'styles/global'
import { Footer } from './footer'
import { Header } from './header'

export const Layout: FC<{ headerOnTop?: boolean }> = ({
  children,
  headerOnTop,
}) => {
  const [isFooterOpen, setIsFooterOpen] = useState(false)

  useEffect(() => {
    const detectFooterHash = () => {
      if (window.location.hash === '#footer') {
        setIsFooterOpen(true)
      } else if (isFooterOpen) {
        setIsFooterOpen(false)
      }
    }

    window.addEventListener('hashchange', detectFooterHash, false)
    detectFooterHash()

    return () => {
      window.removeEventListener('hashchange', detectFooterHash, false)
    }
  }, [isFooterOpen])

  return (
    <>
      <Header onTop={headerOnTop} />
      <FontStyles />
      <GlobalStyle />
      {children}
      <Footer />
    </>
  )
}
